<div
  class="policy-item"
  *ngIf="showCard"
>
  <ion-button
      fill="clear"
      class="policies-toggle-btn d-flex ion-justify-content-between pad6"
      (click)="toggleTermsAndConditions()"
    >
      <div class="policies-toggle-content">
        <ion-text class="fs-3 font700 ion-text-left blue-text-color">{{
          "esim.terms_and_conditions.title" | translate
        }}</ion-text>
        <ion-icon
          [name]="
            expanded ? 'chevron-up-outline' : 'chevron-down-outline'
          "
          class="policies-icon fs-5"
        ></ion-icon>
      </div>
  </ion-button>

  <div class="policies-content ion-padding" *ngIf="expanded">
      <div class="terms-content">
        <b class="fs-4 font600 text-color">{{
          "terms_and_conditions.terms_and_conditions" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.terms_and_conditions.intro' | translate"
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_1_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_1_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_2_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_2_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_3_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_3_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_4_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_4_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_5_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_5_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_6_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_6_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_7_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_7_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_8_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_8_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_9_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_9_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_10_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_10_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_11_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_11_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_12_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_12_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_13_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_13_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_14_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_14_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_15_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_15_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_16_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_16_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_17_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_17_content' | translate
          "
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.section_18_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="
            'esim.terms_and_conditions.section_18_content' | translate
          "
        ></p>

        <hr />
        <b class="fs-3 font600 text-color">{{
          "esim.terms_and_conditions.schedule_a_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.terms_and_conditions.schedule_a1' | translate"
        ></p>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.terms_and_conditions.schedule_a2' | translate"
        ></p>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.terms_and_conditions.schedule_a3' | translate"
        ></p>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.terms_and_conditions.schedule_a4' | translate"
        ></p>
      </div>
    </div>
</div>
